const DEFAULT_FORM_STATE_STORE = {
	name: undefined,
	isFormActive: false,
	isFormDirty: false,
};

export {DEFAULT_FORM_STATE_STORE};
